
 
 

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { ArchwizardModule } from 'angular-archwizard';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
 
import { RouterModule } from '@angular/router';
 
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxPrintElementModule } from 'ngx-print-element';
 
import { NgApexchartsModule } from 'ng-apexcharts';
 
import { AgmCoreModule} from '@agm/core';
// **  
import {NgxPaginationModule} from 'ngx-pagination';

// cookie 
import { CookieService } from 'ngx-cookie-service'


import { DxReportViewerModule } from 'devexpress-reporting-angular';
import { ViewCityComponent } from './city/view-city/view-city.component';
import { InsertCityComponent } from './city/insert-city/insert-city.component';
import { ViewCountryComponent } from './country/view-country/view-country.component';
import { InsertCountryComponent } from './country/insert-country/insert-country.component';
import { ViewGovernorateComponent } from './Governrate/view-governorate/view-governorate.component';
import { InsertGovernorateComponent } from './Governrate/insert-governorate/insert-governorate.component';
import { ViewNewsComponent } from './News/view-news/view-news.component';
import { InsertNewsComponent } from './News/insert-news/insert-news.component';
import { ViewPhotoComponent } from './photo/view-photo/view-photo.component';
import { InsertPhotoComponent } from './photo/insert-photo/insert-photo.component';
import { ViewPhotoAlbumComponent } from './photo-album/view-photo-album/view-photo-album.component';
import { InsertPhotoAlbumComponent } from './photo-album/insert-photo-album/insert-photo-album.component';
import { ViewUserComponent } from './User/view-user/view-user.component';
import { InsertUserComponent } from './User/insert-user/insert-user.component';
import { ViewVideoComponent } from './video/view-video/view-video.component';
import { InsertVideoComponent } from './video/insert-video/insert-video.component';
import { ViewVideoAlbumComponent } from './video-album/view-video-album/view-video-album.component';
import { InsertVideoAlbumComponent } from './video-album/insert-video-album/insert-video-album.component';
import { ChangePasswordComponent } from './User/change-password/change-password.component';
import { ViewKeywordsComponent } from './keywords/view-keywords/view-keywords.component';
import { InsertKeywordsComponent } from './keywords/insert-keywords/insert-keywords.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ListProjectsComponent } from './Projects/Project/list-projects/list-projects.component';
import { InsertProjectComponent } from './Projects/Project/insert-project/insert-project.component';
import { InsertProjectAccomplishmentComponent } from './Projects/project-accomplishment/insert-project-accomplishment/insert-project-accomplishment.component';
import { ListProjectAccomplishmentComponent } from './Projects/project-accomplishment/list-project-accomplishment/list-project-accomplishment.component';
import { InquiryComponent } from './inquiry/inquiry.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { JobRequestReportComponent } from './Report/job-request-report/job-request-report.component';
import { VoluntaryRequestReportComponent } from './Report/voluntary-request-report/voluntary-request-report.component';
import { TrainingCoursesReportComponent } from './Report/training-courses-report/training-courses-report.component';
import { NationalOrganizationReportComponent } from './Report/national-organization-report/national-organization-report.component';
import { PartnerRequestReportComponent } from './Report/partner-request-report/partner-request-report.component';
import { ReportsServiceComponent } from './Report/reports-service/reports-service.component';
import { InsertOurPartnersComponent } from './OurPartners/insert-our-partners/insert-our-partners.component';
import { ListOurPartnersComponent } from './OurPartners/list-our-partners/list-our-partners.component';
import { ListDonationWayComponent } from './DonationWay/list-donation-way/list-donation-way.component';
import { InsertDonationWayComponent } from './DonationWay/insert-donation-way/insert-donation-way.component';
import { SharedModule } from '../../shared/shared.module';
import { DonationsReportComponent } from './Report/donations-reports/donations-reports.component';
import { OnlineDonationsStatsComponent } from './Stats/Online-Donations-Stats/Online-Donations-Stats.component';

// import { DxReportViewerModule } from 'devexpress-angular/reporting/viewer';

 @NgModule({
  declarations: [
    ViewCityComponent,
    InsertCityComponent,
    ViewCountryComponent,
    InsertCountryComponent,
    ViewGovernorateComponent,
    InsertGovernorateComponent,
    ViewNewsComponent,
    InsertNewsComponent,
    ViewPhotoComponent,
    InsertPhotoComponent,
    ViewPhotoAlbumComponent,
    InsertPhotoAlbumComponent,
    ViewUserComponent,
    InsertUserComponent,
    ViewVideoComponent,
    InsertVideoComponent,
    ViewVideoAlbumComponent,
    InsertVideoAlbumComponent,
    ChangePasswordComponent,
    ViewKeywordsComponent,
    InsertKeywordsComponent,
    ListProjectsComponent,
    InsertProjectComponent,
    InsertProjectAccomplishmentComponent,
    ListProjectAccomplishmentComponent,
    InsertOurPartnersComponent,
    ListOurPartnersComponent,
    InquiryComponent,
    JobRequestReportComponent,
    VoluntaryRequestReportComponent,
    TrainingCoursesReportComponent,
    NationalOrganizationReportComponent,
    PartnerRequestReportComponent,
    ReportsServiceComponent,
    ListDonationWayComponent,
    InsertDonationWayComponent,
    DonationsReportComponent, 
    OnlineDonationsStatsComponent
  ],
  imports: [
    AngularEditorModule,
    PdfViewerModule,
    DxReportViewerModule,
    CommonModule,
    AdminRoutingModule,
    SharedModule,
    ArchwizardModule,
    SweetAlert2Module,
    NgxPaginationModule,
    RouterModule,
    NgApexchartsModule,
    NgxPrintElementModule,
    NgMultiSelectDropDownModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey:'AIzaSyANjlA2OTWMRWUTUsu1D7ptP0D5PvW7U8E'
    })
   
  ],
  providers: [
   CookieService
  ],
  
  exports:[ ]
})

export class AdminModule { }
